import React from 'react';
import DedicatedIPsInput from './DedicatedIPsInput';
import ExtraStorageInput from './ExtraStorageInput';

const AddonsStep = ({
  dedicatedIPs,
  setDedicatedIPs,
  ipPriceTotal,
  IP_PRICE_PER_UNIT,
  extraStorage,
  setExtraStorage,
  storagePriceTotal,
  STORAGE_PRICE_PER_UNIT
}) => {
  return (
    <div className="space-y-4 animation-fade-in">
      <div className="bg-[#022A52] bg-opacity-40 p-3 rounded-xl border border-[#033A6A]">
        <p className="text-xs text-gray-300 leading-relaxed">
          💡 <strong>Optional Expansion:</strong> Allocate secondary static IP spaces or connect localized enterprise block storage nodes directly to your virtual core array instance layout configurations.
        </p>
      </div>
      
      <DedicatedIPsInput
        dedicatedIPs={dedicatedIPs}
        setDedicatedIPs={setDedicatedIPs}
        ipPriceTotal={ipPriceTotal}
        IP_PRICE_PER_UNIT={IP_PRICE_PER_UNIT}
      />

      <ExtraStorageInput
        extraStorage={extraStorage}
        setExtraStorage={setExtraStorage}
        storagePriceTotal={storagePriceTotal}
        STORAGE_PRICE_PER_UNIT={STORAGE_PRICE_PER_UNIT}
      />
    </div>
  );
};

export default AddonsStep;